class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener("keyup", (event) => (event.code || event.key || "").toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector('.modal__close-button').addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");
    this.summaryToggle.setAttribute("aria-expanded", this.isOpen());
    this.scrollY = 0;
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  lockScroll() {
    /* Overflow-only lock. Fixing the body repositioned the page and pulled
       the sticky header out from under the search band, so opening search
       appeared to jump the page to the top. */
    this.scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
  }

  unlockScroll() {
    document.body.style.overflow = '';
    window.scrollTo(0, this.scrollY);
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }
onBodyClick(event) {
  const cartDrawer = document.querySelector("cart-drawer");
  const isCartDrawerOpen = cartDrawer?.classList.contains("active") || cartDrawer?.isOpen;
  if (isCartDrawerOpen) return;

  // Overlay click should always dismiss search
  if (event.target.classList.contains("modal-overlay")) {
    this.close(false);
    return;
  }

  // Keep search open for predictive-search (typing/focus + ATC from results)
  if (this.querySelector("predictive-search")) return;

  if (!this.contains(event.target)) this.close(false);
}


  open(event) {
    if (this.matches('.header__search')) {
      document.querySelectorAll('localization-form .country-selector:not([hidden])').forEach((panel) => {
        panel.closest('localization-form').hidePanel();
      });
    }
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute("open", true);
    this.summaryToggle.setAttribute("aria-expanded", "true");
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    this.lockScroll();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? (this.returnFocusElement || this.summaryToggle) : null);
    this.detailsContainer.removeAttribute("open");
    this.summaryToggle.setAttribute("aria-expanded", "false");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    const quickAddIsOpen = document.querySelector(".quick-add-modal[open]");
    if (!quickAddIsOpen) {
      document.body.classList.remove("overflow-hidden");
    }
    this.unlockScroll();
  }
}

customElements.define("details-modal", DetailsModal);
